/**
 * The one `bg-card` sheet every expanded-mode renderer draws its content on —
 * the image renderer is the deliberate exception (spec: `bg-muted`, no
 * sheet). Table and HTML override the padding/overflow for their own
 * edge-to-edge content; everything else uses this as-is.
 *
 * @remarks
 * Lives in `@/shared` because both `@/modules/outputs` (which owns the modal)
 * and `@/modules/file-renderer` (which draws file outputs inside it) need it,
 * and file-renderer must not import the feature module that consumes it.
 */
export const EXPANDED_OUTPUT_SHEET_CLASSNAME =
  'min-h-full w-full rounded-xl border border-border bg-card p-6';
